import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4d918034")

_pushScopeId("data-v-4d918034")
const _hoisted_1 = { class: "countryLabel" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "kn-flex" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "fas fa-check"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "kn-dialog--toolbar--primary",
    visible: _ctx.visibility,
    footer: "footer",
    header: _ctx.$t('language.languageSelection'),
    closable: false,
    modal: ""
  }, {
    footer: _withId(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withId(() => [
      _createVNode(_component_Listbox, {
        class: "countryList",
        options: _ctx.languages,
        optionDisabled: "disabled"
      }, {
        option: _withId((slotProps) => [
          _createVNode("div", {
            class: [['p-d-flex', 'p-ai-center', 'countryItem', slotProps.option.locale], "p-my-1"],
            onClick: ($event: any) => (_ctx.changeLanguage(slotProps.option))
          }, [
            _createVNode("img", {
              alt: slotProps.option.locale,
              src: require('@/assets/images/flags/' + slotProps.option.locale.toLowerCase().substring(3, 5) + '.svg'),
              width: "40"
            }, null, 8, ["alt", "src"]),
            _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(`language.${slotProps.option.locale}`)), 1),
            _hoisted_2,
            (slotProps.option.locale === _ctx.$i18n.locale)
              ? (_openBlock(), _createBlock("i", _hoisted_3))
              : _createCommentVNode("", true)
          ], 10, ["onClick"])
        ]),
        _: 1
      }, 8, ["options"])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
})